import { render, staticRenderFns } from "./studnet-semester-exam-list.vue?vue&type=template&id=b825a584"
import script from "./studnet-semester-exam-list.vue?vue&type=script&lang=js"
export * from "./studnet-semester-exam-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports